import React, { createContext, useContext, useState } from "react";
import Home from "./views/home/Home";

const AppContext = createContext();

export const AppProvider = () => {
  const [globalState, setGlobalState] = useState({
    allQuestions: [],
    likeVideo: null,
    studyId: null,
    questions: [],
    aditionalNavbar: false,
    step: "1",
    succesFinal: true,
    like: false,
    dislike: false
  });

  return (
    <>
      <AppContext.Provider value={{ globalState, setGlobalState }}>
      <div className="fullscreen-black">
        <Home />
        </div>
      </AppContext.Provider>
    </>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
